<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="col-xs-12 col-md-5">
        <nav>
          <ul class="terms-details">
            <li>
              <a href="https://admin.trainingport.net/privacy" target="_blank">
                Privacy
              </a>
            </li>
            <li>
              <a href="https://admin.trainingport.net/terms" target="_blank">
                Terms of Use
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-xs-12 col-md-7">
        <nav>
          <ul class="terms-details term-to-right">
            <li>
              <span>&copy; 2006 - {{ year }} {{ reservedRightsWebSite }} All Rights
                Reserved.</span>
            </li>
            <li>
              <span>{{ getRevision() }}</span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>
<script>
import moment from "moment";
import label from "@/consts/label";

export default {
  data() {
    return {
      year: moment().year(),
      reservedRightsWebSite: label.reservedRightsWebSite
    };
  }
};
</script>
<style scoped>
.term-to-right {
  text-align: right;
}
.footer {
  padding-top: 10px;
}

@media (max-width: 1024px) {
  .footer {
    padding: 20px 0 35px;
  }
  .term-to-right {
    text-align: center;
  }
  .terms-details li {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
    width: 100%;
  }
}
</style>
